import { modalAlertStore } from '@/store'
import { modalAlertParameterInterface } from '@/store/ModalAlertStore'

export class ModalAlertService {
  public open(params?: modalAlertParameterInterface) {
    modalAlertStore.open(params)
  }

  public close() {
    modalAlertStore.close()
  }
}
